var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.24 4.47L4.58002 4.34V10.7L19.05 10.93L19.24 4.47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 13.34C13.12 12.9422 12.962 12.5606 12.6807 12.2793C12.3994 11.998 12.0179 11.84 11.62 11.84C11.2222 11.84 10.8407 11.998 10.5594 12.2793C10.2781 12.5606 10.12 12.9422 10.12 13.34C10.12 13.7378 10.2781 14.1194 10.5594 14.4007C10.8407 14.682 11.2222 14.84 11.62 14.84C12.0179 14.84 12.3994 14.682 12.6807 14.4007C12.962 14.1194 13.12 13.7378 13.12 13.34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58001 11.64H5.38C5.85 14.15 7.38 16.9 9.38 18.13L9.27 21.13C10.91 21.2 12.55 21.05 14.19 21.13L14.12 18.13C15.1685 17.4018 16.0578 16.4676 16.7334 15.3845C17.4091 14.3014 17.8571 13.092 18.05 11.83H16.76C16.4392 12.9452 15.7593 13.9233 14.8257 14.6126C13.8922 15.3018 12.7573 15.6637 11.5971 15.6421C10.4369 15.6204 9.31625 15.2164 8.4091 14.4928C7.50195 13.7692 6.859 12.7664 6.58001 11.64Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.4ba271b0c2f2c0456f17baf2be457870.svg";
export { ForwardRef as ReactComponent };